
import "./Skeleton.css";

export const MySkeleton = ({ width, height }) => {
  return (
    <div
      className="skeleton"
      style={{ width: width || "100%", height: height || "100%" }}
    ></div>
  );
};